// @ts-nocheck
import {
    SETTLEMENT_INFO_DRAWER_PROPS_CHANGED,
    SETTLEMENT_MARKETS_CHANGED,
    SETTLEMENT_MARKETS_CLEARED,
    SETTLEMENT_MARKETS_FILTERS_CHANGED,
    SETTLEMENT_TICKETS_CHANGED,
    SETTLEMENT_TICKETS_CLEARED,
} from '../types';
import MonitoringService from '../../services/MonitoringService';
import { changeConfirmModalProps } from './global';
import { generateParams, getNewCancelToken } from '../../utils/api';
import { CANCEL_TOKEN_KEYS, PAGINATION_KEYS } from '../../utils/constants';
import { setPagination } from './pagination';

export const setSettlementTicketsData = data => ({
    type: SETTLEMENT_TICKETS_CHANGED,
    payload: data,
});

export const clearSettlementTicketsData = () => ({
    type: SETTLEMENT_TICKETS_CLEARED,
});

export const fetchSettlementTickets = params => async (dispatch, getStore) => {
    const store = getStore();
    const currentTickets = store.settlement.tickets.data;

    dispatch(setSettlementTicketsData({ data: params.pageIndex > 0 ? currentTickets : [] }));

    const cancelToken = getNewCancelToken(CANCEL_TOKEN_KEYS.settlementTickets);

    dispatch(
        setPagination(PAGINATION_KEYS.settlementTickets, {
            isFetching: true,
        })
    );

    const { info, items: data } = await MonitoringService.getSettlementTickets({
        params,
        cancelToken,
    });

    if (!info.success) {
        dispatch(
            setPagination(PAGINATION_KEYS.settlementTickets, {
                isFetching: false,
            })
        );
        return;
    }

    let newTickets = [];

    if (params.pageIndex > 0) {
        newTickets = currentTickets.concat(data);
    } else {
        newTickets = data;
    }

    const hasMore = data.length >= params.pageSize;

    dispatch(
        setSettlementTicketsData({
            data: newTickets,
        })
    );

    dispatch(
        setPagination(PAGINATION_KEYS.settlementTickets, {
            hasMore,
            page: params.pageIndex,
            isFetching: false,
        })
    );

    return data;
};

export const setSettlementMarketsData = data => ({
    type: SETTLEMENT_MARKETS_CHANGED,
    payload: data,
});

export const clearSettlementMarketsData = () => ({
    type: SETTLEMENT_MARKETS_CLEARED,
});

export const fetchSettlementMarkets = params => async dispatch => {
    dispatch(setSettlementMarketsData({ isFetching: true, data: {} }));

    const cancelToken = getNewCancelToken(CANCEL_TOKEN_KEYS.settlementMarkets);

    const { info, item: data } = await MonitoringService.getSettlementMarkets({
        params,
        cancelToken,
    });

    if (!info.success) {
        dispatch(setSettlementMarketsData({ isFetching: false }));
        return;
    }

    dispatch(
        setSettlementMarketsData({
            data: data ?? {},
            isFetching: false,
        })
    );

    return data;
};

export const onMarketSettlementRequestConfirm = formData => async (dispatch, getStore) => {
    const reduxStore = getStore();
    const { selectedMarkets, selectedSettlementStatus, selectedTicketType, settlementParams } = reduxStore.settlement.markets;

    const [startDate, endDate] = settlementParams.range;

    const data = {
        eventId: settlementParams.eventId,
        startDate: startDate.valueOf(),
        endDate: endDate.valueOf(),
        manuallySettled: settlementParams.manuallySettled,
        settlementStatus: settlementParams.settlementStatus ?? selectedSettlementStatus,
        markets: selectedMarkets,
        comment: formData.commentByUser,
        channel: 'ONLINE',
        ticketType: selectedTicketType,
    };

    const { info, item } = await MonitoringService.changeMarketsSettlementStatus(data);

    if (!info.success) return { info };

    const params = generateParams(settlementParams);
    dispatch(fetchSettlementMarkets(params));

    const newSettlementParams = { ...settlementParams };
    delete newSettlementParams.manuallySettled;
    delete newSettlementParams.settlementStatus;

    dispatch(
        setSettlementMarketsData({
            selectedMarkets: [],
            selectedSettlementStatus: [],
            selectedTicketType: 0,
            settlementParams: newSettlementParams,
        })
    );
    dispatch(changeConfirmModalProps({ isVisible: false }));

    return { info, item };
};

export const setSettlementMarketsFilters = filters => ({
    type: SETTLEMENT_MARKETS_FILTERS_CHANGED,
    payload: filters,
});

export const changeSettlementInfoDrawerProps = payload => ({
    type: SETTLEMENT_INFO_DRAWER_PROPS_CHANGED,
    payload: payload,
});
